import React from "react";
import generateEquipmentTourStepsByRole from "./ch-tour-helper";
import { JoyrideReusableTour } from "@cd/sdds-common-components-react";

type CHTableTourProps = {
  loggedInProfileInfo: {
    role: string;
  };
  start: boolean;
  isButtonLabelHide?: boolean;
  onTourClose?: (data: any) => void;
};

const CHChartsTour = ({ loggedInProfileInfo, start, isButtonLabelHide, onTourClose }:CHTableTourProps ) => {
  return (
    <JoyrideReusableTour
      loggedInProfileInfo={loggedInProfileInfo}
      stepsByRole={(role): TourStep[] => generateEquipmentTourStepsByRole(role, 'charts') as TourStep[]}
      buttonLabel="JR_MenuPositionDataInCharts"
      tourKey="charts-tour"
      start={start}
      onTourClose={onTourClose}
      isButtonLabelHide={isButtonLabelHide}
    />
  );
};

export default CHChartsTour;
